/********************************************************************************
 * Copyright (c) 2022 Cedalo GmbH
 *
 * All rights reserved. This program and the accompanying materials
 * are made available under the terms of the Eclipse Public License 2.0 which accompany this distribution.
 * and Eclipse Distribution License v1.0 which accompany this distribution.
 *
 * The Eclipse Public License is available at
 *   https://www.eclipse.org/legal/epl-2.0/
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
const isDeepEqual = (v1, v2) => {
	if (v1 === v2) return true;
	if (v1 && v2 && typeof v1 === 'object' && typeof v2 === 'object') {
		const keys1 = Object.keys(v1);
		return keys1.length === Object.keys(v2).length && keys1.every((key) => isDeepEqual(v1[key], v2[key]));
	}
	return false;
};

module.exports = isDeepEqual;
